import { ZdsTypography } from '@zera/components'
import React from 'react'
import { AnimatedText } from '../AnimatedText'

type PlainTextProps = {
  text: string
}

export const PlainText = ({ text }: PlainTextProps): JSX.Element => {
  return (
    <ZdsTypography variant="body300">
      <AnimatedText>{text}</AnimatedText>
    </ZdsTypography>
  )
}
